import { CheckGlobalResourceAccessTask } from '@/Ship/Tasks/CheckGlobalResourceAccessTask'

import { LettersTable } from '../Components/LettersTable'
import { LETTER_RESOURCE } from '../Contracts/ILetter'

import type { LetterOwnerField } from '../Contracts/ILetter'

export interface OwnerLettersTabProps {
    /** Поле власника в листі: `client`, `carrier`, `clientContact`, `carrierContact` */
    owner: LetterOwnerField
    /** Значення форми власника; без `uuid` (новий власник) листів ще немає */
    record: { uuid?: unknown } | undefined
}

/**
 * Чи бачить користувач листи взагалі: колекційне `read_collection` ключа
 * `Letter` (`SPEC-013` §11). Окремий рядок і для картки — показувати
 * вкладку, з якої нічого не прочитати, гірше, ніж не показувати.
 */
export const canReadLetters = (): boolean => CheckGlobalResourceAccessTask(LETTER_RESOURCE, 'read_collection')

/**
 * Вміст вкладки «Листи» картки власника (`SPEC-013` §9.2): обгортка
 * `CrmLettersTab` бере його звідси, а не імпортом з надр контейнера.
 *
 * Без права на листи — нічого; без збереженого власника — теж: листи
 * генеруються лише для існуючого.
 */
export const OwnerLettersTab = ({ owner, record }: OwnerLettersTabProps) => {
    const uuid = typeof record?.uuid === 'string' && record.uuid !== '' ? record.uuid : null

    if (uuid === null || !canReadLetters()) return null

    return <LettersTable ownerField={owner} ownerUuid={uuid} />
}
